(() => {
  const config = window.wimGiftWithPurchase;
  if (!config || !window.theme || !theme.pubsub || !theme.routes) return;

  const SOURCE = 'wim-gift-with-purchase';
  const nativeFetch = window.fetch.bind(window);
  let queue = Promise.resolve();

  const isGiftLine = (item) => item.properties && item.properties[config.property] === 'true';

  const getCart = async () => {
    const response = await nativeFetch(`${theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
    return response.json();
  };

  const bundledSections = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    return sections;
  };

  const publish = (cart) => {
    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cart });
  };

  const addGift = async () => {
    const response = await nativeFetch(theme.routes.cart_add_url, {
      ...theme.utils.fetchConfig('javascript'),
      body: JSON.stringify({
        items: [{ id: config.variantId, quantity: 1, properties: { [config.property]: 'true' } }],
        sections: bundledSections()
      })
    });
    const state = await response.json();
    if (state.status) return;

    const cart = await getCart();
    cart.sections = state.sections;
    publish(cart);
  };

  const changeLine = async (key, quantity) => {
    const response = await nativeFetch(theme.routes.cart_change_url, {
      ...theme.utils.fetchConfig(),
      body: JSON.stringify({ id: key, quantity, sections: bundledSections() })
    });
    const state = await response.json();
    if (state.status) return;

    publish(state);
  };

  const syncCart = async () => {
    try {
      const cart = await getCart();
      const giftLines = cart.items.filter(isGiftLine);
      const hasManualGift = cart.items.some((item) => item.variant_id === config.variantId && !isGiftLine(item));
      const qualifyingTotal = cart.items
        .filter((item) => item.variant_id !== config.variantId)
        .reduce((sum, item) => sum + item[config.priceField], 0);
      const qualifies = qualifyingTotal >= config.threshold && !hasManualGift;

      if (qualifies && giftLines.length === 0) {
        await addGift();
      } else if (!qualifies && giftLines.length > 0) {
        await changeLine(giftLines[0].key, 0);
      } else if (qualifies && giftLines[0].quantity !== 1) {
        await changeLine(giftLines[0].key, 1);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Runs one cart check at a time; the returned promise resolves when this call's check has finished.
  const sync = () => {
    queue = queue.then(syncCart);
    return queue;
  };

  const requestUrl = (input) => (typeof input === 'string' ? input : (input && input.url) || String(input));

  // True when the add-to-cart request asks for theme sections, i.e. it comes from the theme, which then publishes its own cart update.
  const rendersThemeSections = (body) => {
    if (typeof body === 'string') return body.includes('"sections"') || body.includes('sections=');
    if (body instanceof FormData || body instanceof URLSearchParams) return body.has('sections');
    return false;
  };

  // Add-to-cart requests from apps (e.g. a bundle builder that goes straight to checkout) resolve only after the gift check.
  window.fetch = async (input, init) => {
    const response = await nativeFetch(input, init);
    if (response.ok && /\/cart\/add(\.js)?(\?|$)/.test(requestUrl(input)) && !rendersThemeSections(init && init.body)) {
      await sync();
    }
    return response;
  };

  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event && event.source === SOURCE) return;
    sync();
  });

  sync();
})();